/* LUNA reveal text — D51. Palo Alto-style scroll reveal: the paragraph sits
   faint on the page and darkens in reading order as you scroll, the edge
   sweeping THROUGH the boundary word (per-word background-clip gradient, the
   boundary word's background-position interpolated each frame).
   Rules honoured: no regex escape sequences (D48 — whitespace normalised via
   String.fromCharCode), DOM work deferred (D40), reduced-motion renders the
   static ink paragraph, no-JS renders the static ink paragraph.

   D260 (Liv, 09-13): ONE REVEAL PER PAGE.
   Liv: "across all pages, only pick one section to have this scrolling effect."
   The ambassador section marks every quote block, so Fran's page was running it
   four times and Shane's, Miles' and Terradrift's three times each. Repeated,
   the effect stops being an effect: the reader meets a second wall of grey text
   and reads it as broken rather than as emphasis, and on a tall quote the tail
   sits unread until they scroll past it. See the screenshot on OPW, where two
   consecutive quotes were both half ghosted at once.

   So the scan now arms exactly one element per page. The rest keep their
   data-luna-rt attribute and simply render as solid ink, which is the same
   fallback path as no-JS and reduced-motion, already the designed default.

   WHICH ONE: the first on the page, unless something carries data-rt-primary,
   which wins. That hook exists so the choice can be moved from the template
   later without touching this file again. */
(function(){
  if(window.__lunaReveal) return; window.__lunaReveal = true;
  var SP = ' ';
  var WS = [String.fromCharCode(10), String.fromCharCode(13), String.fromCharCode(9)];
  function normalize(t){ WS.forEach(function(c){ t = t.split(c).join(SP); }); return t; }
  function wrapWords(node, out){
    if(node.nodeType === 3){
      var parts = normalize(node.textContent).split(SP);
      var frag = document.createDocumentFragment();
      parts.forEach(function(w, i){
        if(i) frag.appendChild(document.createTextNode(SP));
        if(w){
          var s = document.createElement('span');
          s.className = 'luna-rt__w';
          s.textContent = w;
          frag.appendChild(s);
          out.push(s);
        }
      });
      node.parentNode.replaceChild(frag, node);
    } else if(node.nodeType === 1){
      Array.prototype.slice.call(node.childNodes).forEach(function(c){ wrapWords(c, out); });
    }
  }
  function init(root){
    if(root.__luna) return; root.__luna = true;
    var txt = root.querySelector('[data-rt-text]');
    if(!txt) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var words = [];
    wrapWords(txt, words);
    var N = words.length;
    if(!N) return;
    root.classList.add('is-armed');
    var lastBoundary = null, ticking = false, active = false;
    function apply(){
      ticking = false;
      var vh = window.innerHeight || 1;
      var r = txt.getBoundingClientRect();
      var start = vh * 0.85, end = vh * 0.42;
      var span = r.height + (start - end);
      var p = span > 0 ? (start - r.top) / span : 1;
      if(p < 0) p = 0;
      if(p > 1) p = 1;
      var exact = p * N;
      var idx = Math.floor(exact);
      var frac = exact - idx;
      if(lastBoundary){ lastBoundary.style.backgroundPositionX = ''; lastBoundary = null; }
      for(var i = 0; i < N; i++){
        words[i].classList.toggle('is-on', i < idx);
      }
      if(idx < N && frac > 0){
        words[idx].style.backgroundPositionX = ((1 - frac) * 100) + '%';
        lastBoundary = words[idx];
      }
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(apply); } }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting && !active){
          active = true;
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll);
          onScroll();
        } else if(!e.isIntersecting && active){
          active = false;
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          apply();
        }
      });
    }, { rootMargin: '20% 0px 20% 0px' });
    io.observe(root);
    onScroll();
  }
  /* D260: one per page. Everything else stays solid ink. */
  function scan(){
    var all = document.querySelectorAll('[data-luna-rt]');
    if(!all.length) return;
    var chosen = document.querySelector('[data-luna-rt][data-rt-primary]') || all[0];
    init(chosen);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', scan); }
  else { scan(); }
  document.addEventListener('shopify:section:load', scan);
})();